import AppGlobalStyles from "@feg/ui/src/theme/theme/AppGlobalStyles"
import { AppThemeProvider } from "@feg/ui/src/theme/theme/AppThemeProvider"
import { Root } from "./Root"

export function App() {
  return (
    <AppThemeProvider>
      <AppGlobalStyles />
      <Root />
    </AppThemeProvider>
  )
}
